import * as React from 'react';

import { Box, Slider, Typography } from '@mui/material';

import styles from './GenderSplitSlider.module.css';

export interface GenderSplitSliderProps {
  /** Share of female panelists in [0, 1]. */
  female: number;
  onChange: (female: number) => void;
  disabled?: boolean;
  error?: string;
}

const MARKS = [0, 25, 50, 75, 100].map((value) => ({ value }));

const toPercent = (fraction: number) => Math.round(fraction * 100);

/** One slider for a two-way split, so the parts always add up to 100%. */
const GenderSplitSlider: React.FC<GenderSplitSliderProps> = ({
  female,
  onChange,
  disabled,
  error,
}) => {
  const femalePercent = toPercent(female);
  const malePercent = 100 - femalePercent;
  return (
    <Box>
      <Box className={styles.legend}>
        <Typography variant="body2">
          <strong>{femalePercent}%</strong> female
        </Typography>
        <Typography variant="body2">
          <strong>{malePercent}%</strong> male
        </Typography>
      </Box>
      <Slider
        aria-label="Female share of panel"
        value={femalePercent}
        min={0}
        max={100}
        step={1}
        marks={MARKS}
        disabled={disabled}
        valueLabelDisplay="auto"
        valueLabelFormat={(v) => `${v}% female · ${100 - v}% male`}
        getAriaValueText={(v) => `${v}% female, ${100 - v}% male`}
        onChange={(_, v) => onChange((v as number) / 100)}
        color={error ? 'error' : 'primary'}
      />
      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default GenderSplitSlider;
